// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"f7777f3e","429":"e07808ca","453":"b0e8e29e"}[chunkId] + ".chunk.js";
};